// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__23qid","left":"StickyBox_left___-RXB","right":"StickyBox_right__2AyEt"};